import {
  Component,
  Inject,
  inject,
  PLATFORM_ID,
  Signal,
} from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectAllSiteSettings } from '../../../components/home/redux/selectors/home.selectors';
import { map, startWith } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  private store = inject(Store);
  private router = inject(Router);
  dataBind: any;
  siteSettingsState: Signal<{ siteSettings: any }>;
  isBrowser: any;

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    this.siteSettingsState = toSignal(
      this.store.select(selectAllSiteSettings).pipe(
        startWith({ siteSettings: [], isLoading: false, error: null }),
        map((state) => ({
          siteSettings: state.siteSettings || [], // Ensure siteSettings is always an array
        }))
      ),
      { initialValue: { siteSettings: [] } }
    );
  }

  ngOnInit(): void {}

  goToPage(link: any) {
    if (this.isBrowser && link) {
      const newLink = `https://tripxl.com${link}`;
      window.open(newLink, '_blank', 'noopener,noreferrer');
    }
  }

  goToPageDest(link: any) {
    if (this.isBrowser && link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  }

  navigateToHome() {
    this.router.navigate(['/home']);
  }
}
